import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { authSlice } from '@starjack/features/authentication';
import { notify } from '@starjack/features/notifications';

export const authMiddleware: Middleware = (api) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const payload = action.payload as
            | { status?: number; data?: { errors?: Array<{ error?: string }> } }
            | undefined;
        if (payload?.status == 401) {
            api.dispatch(
                authSlice.actions.clearAuthData({
                    userLogout: false,
                })
            );
            // fetchBaseQuery puts the response body under `data`
            const error = payload?.data?.errors?.[0];
            if (error?.error !== 'token_expired') {
                notify({
                    type: 'error',
                    message: 'Fehler beim Laden der Daten.',
                    id: 'auth-401',
                });
            }
            return;
        }
    }

    return next(action);
};
